import { render, staticRenderFns } from "./TermsAndConditionalModal.vue?vue&type=template&id=319ade81&scoped=true&"
import script from "./TermsAndConditionalModal.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionalModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionalModal.vue?vue&type=style&index=0&id=319ade81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319ade81",
  null
  
)

export default component.exports